import { Media } from './ModalMedia.styles';

interface ModalMediaProps {
  image: string | undefined;
}

const ModalMedia = ({ image }: ModalMediaProps) => <Media image={image} />;

export default ModalMedia;
